export default function timecodeFilter(timecode) {
  const seconds = timecode / 1000
  const hours = Math.floor(seconds / 3600)
  const remainingSeconds = seconds - hours * 3600
  const minutes = Math.floor(remainingSeconds / 60)
  const remainingSecondsFinal = Math.round(remainingSeconds - minutes * 60)

  const formattedHours = String(hours).padStart(2, '0')
  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(remainingSecondsFinal).padStart(2, '0')

  if (hours > 0) {
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
  } else {
    return `${formattedMinutes}:${formattedSeconds}`
  }
}
